import React from 'react';
import { CTAButton } from '../CTAButton';
import { AUTHOR_PHOTO } from '../../data/content';
export function Author() {
  return <section className="w-full bg-white py-14 sm:py-20" data-id="element-65" data-mp="1htc4f2xid7em">
      <div className="mx-auto w-full max-w-5xl px-4" data-id="element-66" data-mp="1wgf4nhd7tu5n">
        <div className="grid grid-cols-1 items-center gap-8 md:grid-cols-2 md:gap-12" data-id="element-67" data-mp="1whzy13nsn71x">
          <div className="mx-auto w-full max-w-sm overflow-hidden rounded-3xl bg-navy-50 md:max-w-none" data-id="element-68" data-mp="1roduq23isfis">
            <img src={AUTHOR_PHOTO} alt="Dr. Karito, creator of Aligner Control System" className="h-full w-full object-cover" width={943} height={1690} data-id="element-69" data-mp="25fileeowtxgz" />
          </div>

          <div data-id="element-70" data-mp="2afwwy6ppzpjr">
            <p className="text-xs font-extrabold uppercase tracking-[0.18em] text-sky-600" data-id="element-71" data-mp="2ahhpjqsh4yez">
              👩‍⚕️ Created by Dr. Karito
            </p>
            <h2 className="mt-3 font-display text-[26px] font-black uppercase leading-[1.12] text-navy-800 sm:text-4xl" data-id="element-72" data-mp="l3cvh7dg46vi">
              A practical system built for dentists working with aligners
            </h2>
            <div className="mt-5 flex flex-col gap-4 text-base leading-relaxed text-navy-600" data-id="element-73" data-mp="3kfxzd064cfaq">
              <p data-id="element-74" data-mp="3pf15knxu4rka">
                After working with the realities of clinical practice, Dr. Karito
                recognized a common problem: dentists don’t necessarily lack
                information. They often lack a simple system for organizing that
                information when they actually need to use it.
              </p>
              <p data-id="element-75" data-mp="7xhy14djaj5z">
                That’s why ALIGNER CONTROL SYSTEM™ was created. Not as another
                lengthy course. Not as another theoretical ebook. But as a
                practical collection of frameworks, checklists, protocols,
                trackers, and review tools designed to help organize the workflow
                surrounding aligner cases.
              </p>
            </div>

            <p className="mt-6 font-display text-lg font-black uppercase leading-tight text-navy-800" data-id="element-76" data-mp="2irdo8zn8ul0j">
              Less scattered information.
              <br data-id="element-77" data-mp="3h2ewb1s6ozhs" />
              More structure.
              <br data-id="element-78" data-mp="3h3qbryuzrvoq" />
              <span className="text-sky-600" data-id="element-79" data-mp="3h49jkmqxh3p1">A clearer workflow.</span>
            </p>
          </div>
        </div>

        <div className="mt-10 flex justify-center" data-id="element-80" data-mp="3v03kojlgmorl">
          <CTAButton label="Get the system Dr. Karito built" data-id="element-81" data-mp="3q21yhpsqm9bw" />
        </div>
      </div>
    </section>;
}